/**
 * Shared loader for Jitsi's external iframe API (`external_api.js`). It is loaded
 * at runtime from config (e.g. https://alpha.jitsi.net/external_api.js), NOT
 * bundled — the same approach spot-client uses (`loadScript(getExternalApiUrl)`).
 *
 * The TV's {@link ./JitsiMeetingFrame} needs this global. (The laptop `/share`
 * remote uses the heavier full lib-jitsi-meet instead — see ../share/lib-jitsi-meet.)
 * The idempotent single-load lives here (one `<script>` per document, shared
 * promise across callers).
 */

let externalApiLoad: Promise<void> | null = null;

/** Load external_api.js once per document (idempotent across callers/mounts). */
export function loadExternalApi(src: string): Promise<void> {
    if (window.JitsiMeetExternalAPI) {
        return Promise.resolve();
    }

    if (externalApiLoad) {
        return externalApiLoad;
    }

    externalApiLoad = new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');

        script.src = src;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => {
            externalApiLoad = null;
            reject(new Error(`failed to load Jitsi external_api.js from ${src}`));
        };
        document.head.appendChild(script);
    });

    return externalApiLoad;
}
